import { render, staticRenderFns } from "./ClinicAvailability.vue?vue&type=template&id=1152c94f&scoped=true&"
import script from "./ClinicAvailability.vue?vue&type=script&lang=js&"
export * from "./ClinicAvailability.vue?vue&type=script&lang=js&"
import style0 from "./ClinicAvailability.vue?vue&type=style&index=0&id=1152c94f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1152c94f",
  null
  
)

export default component.exports